<!--
 * @Autor: Baowang
 * @Date: 2024-11-20 11:46:05
 * @pageName: 忘记密码
 * @LastEditTime: 2024-11-20 16:37:36
-->
<template>
  <div class="logout">
    <el-dialog :visible.sync="$store.state.logoutFable" center :title="$t('login.logout')" :before-close="cancel" top="0">
      <div class="logout_centent animate__animated animate__zoomIn">
        <!-- <div class="logout_title">退出登录</div> -->
        <div class="logout_text">{{ $t('login.logoutText') }}</div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button class="cancelBtn" @click="cancel">{{ $t('login.cancel') }}</el-button>
        <el-button class="confirmBtn" @click="confirm">{{ $t('login.confirm') }}</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
export default {
  data() {
    return {

    };
  },
  methods: {
    // 确认
    confirm() {
      this.$store.commit('updataLogout', false)
      this.$store.commit("updateMe", {});
      this.$store.commit('upDatetopindex', 0)
      this.$router.push("/");
    },
    // 取消
    cancel() {
      this.$store.commit('updataLogout', false)
    },
  },
};
</script>
<style lang="less" scoped>
.logout {
  width: 100%;
  font-family: Arial, "Helvetica Neue", Helvetica, sans-serif;

  /deep/ .el-dialog {
    width: 400px;
    height: 230px;
    background: #FFFFFF;
    border-radius: 20px 20px 20px 20px;
  }

  /deep/ .el-dialog__wrapper {
    display: flex;
    align-items: center;
    justify-content: center;
  }

  /deep/ .el-dialog__close {
    font-size: 30px;
  }

  .logout_text {
    text-align: center;
    font-size: 18px;
  }

  .cancelBtn {
    width: 118px;
    height: 46px;
    background: #EFEFEF;
    border-radius: 10px 10px 10px 10px;
    margin-right: 30px;
  }

  .confirmBtn {
    width: 118px;
    height: 46px;
    background: #E70012;
    border-radius: 10px 10px 10px 10px;
    color: white;
  }
}
</style>
